import { useBackend } from "../../services";

export const useGetAlbum = () => {
  const { get } = useBackend();
  const getAlbum = (albumUuid: string) => get(`albums/${albumUuid}`);
  return { getAlbum };
};
